module.exports = __webpack_public_path__ + "static/media/direct-freight-express.18b9d9cf.svg";